﻿import { createElement, onEvent } from "./_dom";
import { Modal } from "./_modal";

let autocompleteModal;

const setValueEvents = {};

function getSpinner() {
	const spinner = createElement('div', {
		class: 'v3-map-spinner',
		style: {
			position: "absolute",
			left: "50%",
			top: "50%",
			"margin-top": "-30px",
			"margin-left": "-30px"
		}
	},
		createElement("div", { class: "v3-spinner-big" }, createElement("div"))
	);
	return spinner;
}

function open(trigger) {
	const id = trigger.dataset.recordpickerValue;
	let url = trigger.dataset.recordpickerUrl;
	url = getUrl(id, url, trigger);
	if (url !== undefined) {
		const modalContent = createElement("iframe", { src: url, id: `autocomplete-${id}`, name: `popup_${id}` });
		autocompleteModal = new Modal(modalContent).start();
		const modal = autocompleteModal.element;
		const spinner = getSpinner();
		modal.append(spinner);
		modalContent.addEventListener("load", () => spinner.remove(), { once: true });
	}
}

function close(/*id*/) {
	if (autocompleteModal.element) {
		autocompleteModal.removeModal();
	}
}

// TODO: remove
function decodeMessageHack(messageData) {
	// HACK we normally wont need this but we have inline-generated script in recordpicker.aspx for v2
	if (typeof messageData !== "string" || messageData.indexOf("WM_RECORDPICKERSETRESULT\n") !== 0)
		return messageData;
	const [type, id, value, ...text] = messageData.split("\n");
	return { type, id, value, text: text.join("\n") };
}

function setResult(value, text) {
	var id = window.name;
	if (id.indexOf("popup_") === 0) {
		window.parent.postMessage({ type: "WM_RECORDPICKERSETRESULT", id: id.substring(6), value, text });
	}
}

// 1. Browse choices: id = trigger = SELECT
// 2. Type In: id is hidden, trigger is button
// 3. Browse choices with table picker: id is hidden, trigger is SELECT
// 4. Browse choices with table picker: id is hidden and outside of picker trigger is BUTTON
/**
 * 
 * @param {string} id
 * @param {string} url
 * @param {HTMLSelectElement|HTMLButtonElement} trigger
 * @returns {string|undefined}
 */
function getUrl(id, url, trigger) {
	const ctrl = document.getElementById(id);
	trigger ??= ctrl;
	if (ctrl.matches("SELECT")) {
		const options = ctrl.options;
		if (ctrl.selectedIndex != options.length - 1) {
			return;
		}
		// we are at Browse Choices...
		// set selection back while user is choosing.
		ctrl.selectedIndex = options.length - 2;
	} else if (ctrl.value === "") {
		const s = trigger.parentElement.querySelector(".v3-typeinpicker__input")?.value;
		if (s) {
			url += "&search=" + encodeURIComponent(s);
		}
	}
	return url;
}

function setSelectValue(ctrl, value, text) {
	var o, oo = ctrl.options;
	for (var i = 1; i < oo.length - 1; i++) {
		var x = oo[i];
		if (x.value == value) {
			if (x.selected) return false;
			o = x;
			break;
		}
	}
	if (!o) {
		o = new Option(text, value);
		ctrl.insertBefore(o, oo[oo.length - 1]);
	}
	o.selected = true;
	return true;
}

// 1. Browse choices: id = trigger = SELECT
// 2. Type In: id is hidden, trigger is button
// 3. Browse choices with table picker: id is hidden, trigger is SELECT
// 4. Browse choices with table picker: id is hidden and outside of picker trigger is BUTTON
/**
 * @param {string} id
 * @param {string} value
 * @param {string} text
 * @returns {void}
 */
function setValue(id, value, text) {
	var ctrl = document.getElementById(id);
	const form = ctrl.form;
	const n = ctrl.name;
	if (ctrl.matches("select")) {
		// select, no multi-table
		// it's an only case the value is set directly to control
		// in all the other case the value is stored in hidden
		if (setSelectValue(ctrl, value, text)) {
			try {
				setValueEvents.id = 1;
				ctrl.dispatchEvent(new Event("change", { bubbles: true }));
			} finally {
				delete setValueEvents.id;
			}
		}
	} else {
		const multiTable = form.querySelector(`select[name="${n}_table"]`);
		let currentPickerIsSelect = false;
		if (multiTable) {
			const currentPicker = document.getElementById(`${n}_${multiTable.selectedIndex}`);
			currentPickerIsSelect = currentPicker.matches("select");
			if (currentPickerIsSelect) {
				// select, multi-table
				setSelectValue(currentPicker, value, text);
			} else {
				// type-in, multi-table
				const typeInText = currentPicker.querySelector(".v3-typeinpicker__input");
				typeInText.value = text;
			}
		}
		if (!currentPickerIsSelect) {
			const textValue = form.querySelector(`input[name="${n}_text"]`);
			textValue.value = text;
		}
		if (ctrl.value !== value) {
			ctrl.value = value;
			ctrl.dispatchEvent(new Event("change", { bubbles: true }));
		}
	}
}

function onSetResultMessage(e) {
	var msg = decodeMessageHack(e.data);
	if (msg.type === "WM_RECORDPICKERSETRESULT") {
		close(msg.id);
		setValue(msg.id, msg.value, msg.text);
	}
}

window.addEventListener("message", onSetResultMessage, false);

function init(context) {
	onEvent(context, "button[data-recordpicker-value][data-recordpicker-url]", "click", (_event, button) => open(button));
	onEvent(context, "select[data-recordpicker-value][data-recordpicker-url]", "change", (_event, select) => setValueEvents[select.id] === undefined && open(select));
	onEvent(context, "[data-recordpicker-set-value][data-recordpicker-set-text]", "click", (_event, button) => {
		setResult(button.dataset.recordpickerSetValue, button.dataset.recordpickerSetText);
	});
}

export { init, getUrl, setValue /*, open, close, setValue, setResult*/ };
